import { useNavigate } from 'react-router-dom';
import css from './back-button.module.scss';
import { ReactComponent as ArrowLongLeft } from 'src/assets/arrow-long-left.svg';

interface BackButtonProps {
  backLink?: string;
}

export default function BackButton({ backLink }: Readonly<BackButtonProps>) {
  const navigate = useNavigate();

  return (
    <div>
      <button className={css.backButton} onClick={() => (backLink ? navigate(backLink) : navigate(-1))}>
        <ArrowLongLeft />
        <span>Назад</span>
      </button>
    </div>
  );
}
